import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';

export type DeleteAudienceParams = {
  audienceId: string;
};

export const deleteAudience = async (
  params: DeleteAudienceParams,
): Promise<void> => {
  return await tinctApi.audiences.deleteAudience(params.audienceId);
};

export const useDeleteAudience = (
  options?: Omit<
    UseMutationOptions<void, ApiError, DeleteAudienceParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAudience,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['audiences'],
      });
      queryClient.removeQueries({
        queryKey: ['audience', args[1].audienceId],
      });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
